var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex flex-col gap-2 px-4"
  }, [_c('div', [_c('Form', {
    staticClass: "flex w-full justify-start",
    attrs: {
      "inline": ""
    }
  }, [_c('FormItem', [_c('Input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "clearable": "",
      "placeholder": $t("3xe0njg", "请输入姓名、手机号、邮箱进行搜索"),
      "suffix": "ios-search"
    },
    on: {
      "on-enter": _vm.query,
      "on-change": _vm.query
    },
    model: {
      value: _vm.searchParams.search,
      callback: function ($$v) {
        _vm.$set(_vm.searchParams, "search", $$v);
      },
      expression: "searchParams.search"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label-width": 0
    }
  }, [_c('Select', {
    directives: [{
      name: "width",
      rawName: "v-width",
      value: 300,
      expression: "300"
    }],
    staticClass: "firefox-select-focus-fix text-[14px]",
    attrs: {
      "multiple": "",
      "filterable": "",
      "clerable": "",
      "placeholder": $t("2eief25", "请选择状态")
    },
    on: {
      "on-change": _vm.query
    },
    model: {
      value: _vm.searchParams.statusList,
      callback: function ($$v) {
        _vm.$set(_vm.searchParams, "statusList", $$v);
      },
      expression: "searchParams.statusList"
    }
  }, _vm._l(_vm.tagMap, function (item, index) {
    return _c('Option', {
      key: index,
      attrs: {
        "value": index
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1)], 1)], 1)], 1), _c('pro-table', _vm._b({
    ref: "tableRef"
  }, 'pro-table', _vm.config, false))], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };